const titleize = (value) => {
  if (!value) { return ''; }

  return value.replace(/_/g, ' ');
};

export default titleize;
